// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-2OTqG","dropdown":"dropdown-2m-GQ"};